var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetProfileEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#bfebff;}.cls-3{fill:#febe10;}.cls-4{fill:#fffbc5;}.cls-5{fill:#4d4d4d;}.cls-6{fill:#71c2ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.76,
    y: 0.25,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.76,
    y: 0.25,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "edit_profile_copy",
    "data-name": "edit profile copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546,106.19v442a50,50,0,0,1-50,50.07H54.78a50,50,0,0,1-50-50.07V241L189.37,56.12H496A50,50,0,0,1,546,106.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.68,404.86l-92.32-92.27,303.11-303a22.43,22.43,0,0,1,31.71,0L592.82,70.2a22.4,22.4,0,0,1,0,31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.68,372l-32,1.9h0l1.89-31.93-31.93,1.9-.29-.28,1.9-32-32,1.9-.15-.15,0,.16H198l.06.06-24,89.44a35.35,35.35,0,0,1,25.31,25.3l89.7-24-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.37,428.29l-34.58,9.25L174.06,403A35.35,35.35,0,0,1,199.37,428.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188,56.61V190.25a49.37,49.37,0,0,1-49.32,49.41H5.3Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileEdit);
export default __webpack_public_path__ + "static/media/pet_profile_edit.4cb191e895c836eb838dc4f55cb2de39.svg";
export { ForwardRef as ReactComponent };